import routeConfig from 'edge/fnol/ca/config/RouteConfig';
import VehicleDamagePicker from 'edge/fnol/ca/directives/VehicleDamagePicker';
import VehicleDamageablePart from 'edge/fnol/ca/directives/VehicleDamageablePart';
import DamageList from 'edge/fnol/ca/directives/DamageList';
import VehicleCollision from 'edge/fnol/ca/directives/VehicleCollision';
import AddNewVehicle from 'edge/fnol/ca/directives/AddNewVehicle';
import AddNewDriver from 'edge/fnol/ca/directives/AddNewDriver';
import VehicleIncident from 'edge/fnol/ca/directives/VehicleIncident';
import MapTypeControl from 'edge/fnol/ca/components/MapTypeControl';
import MapSearch from 'edge/fnol/ca/components/MapSearch';
import SelectionSummary from 'edge/fnol/ca/components/SelectionSummary';
import 'edge/fnol/common/app';

export default angular.module('edge.fnol.ca.app', ['edge.fnol.common.app']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = routeConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).constant('fleetPageSize', 20).directive('gwFnolCaVehicleDamagePicker', VehicleDamagePicker).directive('gwFnolCaDamageList', DamageList).directive('gwFnolCaVehicleCollision', VehicleCollision).directive('gwFnolCaAddNewVehicle', AddNewVehicle).directive('gwFnolCaAddNewDriver', AddNewDriver).directive('gwFnolCaVehicleIncident', VehicleIncident).directive('gwFnolCaVehicleDamageablePart', VehicleDamageablePart).component('gwFnolCaMapTypeControl', MapTypeControl).component('gwFnolCaMapSearch', MapSearch).component('gwFnolCaSelectionSummary', SelectionSummary);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=fnol-lob&equals=ca!./common/js/src/edge/fnol/ca/app.js
// module id = 448
// module chunks = 0